import JWTApi from "../libs/login/JWTApi";
import { IFood, INut } from "../shared/IFood";
import { IRecipe } from "../shared/Recipes";

export default class FoodApi extends JWTApi {
    static _i:FoodApi
    static get i(){
        if (!this._i) this._i = new FoodApi()
        return this._i
    }
    foods(){
        return this.api.get<IFood[]>("/1/foods").then(data => data.data)
    }
    nutrients(){
        return this.api.get<INut[]>("/1/nutrients").then(data => data.data)
    }
    recipes(){
        return this.api.get<IRecipe[]>("/1/recipes/me").then(data => data.data)
    }
    addRecipe(name:string,description:string,servings:number){
        return this.api.post<IRecipe>("/1/recipes/me", {name,description,servings}).then(data => data.data)
    }
    updateRecipe(id:string,recipe:Partial<IRecipe>){
        return this.api.post<IRecipe>("/1/recipes/me/"+id, recipe).then(data => data.data)
    }
}